import { render } from "./InputSocialMedia.vue?vue&type=template&id=368a0934"
import script from "./InputSocialMedia.vue?vue&type=script&lang=js"
export * from "./InputSocialMedia.vue?vue&type=script&lang=js"
script.render = render

export default script